module.exports = __webpack_public_path__ + "static/pic-7c667cbbd772d2809f577e43a596a7a0.jpg";